module.exports = __webpack_public_path__ + "img/c05_unitprimuspilus_Normal_ua.97614ca6.webp";